import { EAV_ATTRIBUTE_TYPES_EXCLUDED_IN_PERSONAL_ACCOUNT } from '@zaoblako/shared/modules/eav/constants/eav-attribute-types-excluded-in-personal-account.constants';
import type { EavAttributeValueTypeEnum } from '@zaoblako/shared/modules/eav/enums/eav-attribute-value-type.enum';

/** Resolve persisted `showInPersonalAccount` from type and requested value */
export const resolveEavAttributeShowInPersonalAccount = (
  type: EavAttributeValueTypeEnum,
  showInPersonalAccount?: boolean,
): boolean => {
  if (EAV_ATTRIBUTE_TYPES_EXCLUDED_IN_PERSONAL_ACCOUNT.includes(type)) {
    return false;
  }

  return showInPersonalAccount === true;
};
